module.exports = "/static-assets/_next/static/images/building-blocks-e97ae2303c5baa951edaa6d0e70428c3.png";